module.exports = __webpack_public_path__ + "static/pemalex_img_estamparia_2_h-bec8e0f3deaa1335b09769e0ea9f6516.jpg";